// src/components/Home.js

import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/MatchTables.css";
import { getLatestMatches } from "../api";
import { useSeason } from "../contexts/SeasonContext";
import {
    formatDateTime24,
    timeAgo,
    rowClassName,
    getBallincolligTeam
} from "../utils/formatting";
import { getFixtureColumns, getResultColumns, cellStyle } from "../utils/columnDefinitions";
import MatchTable from "../components/MatchTable";
import MatchDetailModal, { useMatchDetailModal } from "../components/MatchDetailModal";

const Home = ({ clubName }) => {
    const { selectedSeason } = useSeason();
    const [upcomingFixtures, setUpcomingFixtures] = useState([]);
    const [recentResults, setRecentResults] = useState([]);
    const [lastModified, setLastModified] = useState({ fixtures: null, results: null });
    const [loading, setLoading] = useState(true);
    const matchDetailModal = useMatchDetailModal();

    // Get column definitions
    const fixtureColumns = getFixtureColumns(true);
    const resultColumns = getResultColumns(true, true);

    useEffect(() => {
        async function fetchLatest() {
            try {
                const data = await getLatestMatches(selectedSeason);
                setUpcomingFixtures(data.fixtures || []);
                setRecentResults(data.results || []);
                if (data.lastModified) {
                    setLastModified({
                        fixtures: data.lastModified.fixtures,
                        results: data.lastModified.results,
                    });
                }
                setLoading(false);
            } catch (error) {
                console.error("Error fetching latest data:", error);
                setLoading(false);
            }
        }

        fetchLatest();
    }, [selectedSeason]);

    if (loading) {
        return (
            <div className="container mt-4">
                <h2>Loading dashboard...</h2>
            </div>
        );
    }

    return (
        <div className="container mt-4">
            <h3>Welcome to RugbyCore for {clubName}</h3>

            <hr />

            <h4>Upcoming Fixtures (Next 10 Days)</h4>
            {lastModified.fixtures && (
                <h6 style={{ fontSize: "0.9rem" }}>
                    Last updated: {formatDateTime24(lastModified.fixtures)} ({timeAgo(lastModified.fixtures)})
                </h6>
            )}
            <MatchTable
                columns={fixtureColumns}
                data={upcomingFixtures}
                cellStyle={cellStyle}
                rowClassName={rowClassName}
            />

            <hr />

            <h4>Recent Results (Last 10 Days)</h4>
            {lastModified.results && (
                <h6 style={{ fontSize: "0.9rem" }}>
                    Last updated: {formatDateTime24(lastModified.results)} ({timeAgo(lastModified.results)})
                </h6>
            )}
            <MatchTable
                columns={resultColumns}
                data={recentResults}
                cellStyle={cellStyle}
                rowClassName={rowClassName}
                onRowClick={(item) => {
                    // Only open modal for completed matches with scores
                    const hasScore = (item.ftHome != null && item.ftAway != null) ||
                        (item.homeScore != null && item.awayScore != null);

                    if (hasScore) {
                        const matchId = item.key || item.fid || item.id || item._id;
                        const teamName = getBallincolligTeam(item);
                        matchDetailModal.open(matchId, teamName);
                    }
                }}
            />

            <MatchDetailModal {...matchDetailModal.props} />
        </div>
    );
};

export default Home;
